import {TextFilterModel} from 'ag-grid-community';
import {FilterModel} from '../../../filter-model';
import {ISimpleFilterModelType} from 'ag-grid-community';

export function isTextFilter(
  filterMode: FilterModel<ISimpleFilterModelType>,
): filterMode is TextFilterModel {
  return filterMode.filterType === 'text';
}
